import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'


Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })],
  state: {
    userDetails:{
      "firstname": '',
      "lastname": '',
      "headline": '',
      "about": '',
      "links": '',
      "twitterUrl": '',
      "facebookUrl": '',
      "linkedinUrl": '',
      "youtubeUrl": '',
      "userId": '',
      "imageUrl": '',
    },
  },
  mutations: {
    setUserDetails(state,{data}){
      state.userDetails.firstname= data.firstname;
      state.userDetails.lastname= data.lastname;
      state.userDetails.headline= data.headline;
      state.userDetails.about= data.about;
      state.userDetails.links= data.links;
      state.userDetails.twitterUrl= data.twitterUrl;
      state.userDetails.facebookUrl= data.facebookUrl;
      state.userDetails.linkedinUrl= data.linkedinUrl;
      state.userDetails.youtubeUrl= data.youtubeUrl;
      state.userDetails.userId= data.userId;
      state.userDetails.imageUrl= data.imageUrl;
      console.log(state.userDetails);
    },
  },
  actions: {
  },
  modules: {
  }
})
